import { useRequiredParams } from '@pba/react-router';
import { LandingLayout } from 'layouts';
import { PublicKudos } from 'features/feed';
import { ContentLeft, Footer, Header, type HeaderItem } from 'features/onboarding';
import { useOnboardingNavigation } from '../hooks';
import type { OnboardingLocationState } from '../types';

type RouteParams = {
  kudosId: string;
};

export const PagePublicKudos = () => {
  const { kudosId } = useRequiredParams<RouteParams>();
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onNavigateToPrimaryLogin, onNavigateToSignUp } = useOnboardingNavigation<OnboardingLocationState>();

  const headerButtons: HeaderItem[] = [
    {
      label: 'Log in',
      async onClick() {
        await onNavigateToPrimaryLogin({ referrer: window.location.pathname });
      },
      type: 'tertiary',
    },
    {
      label: 'Sign up',
      async onClick() {
        await onNavigateToSignUp({ referrer: window.location.pathname });
      },
      type: 'tertiary',
    },
  ];

  return (
    <LandingLayout
      contentLeft={<ContentLeft />}
      contentRight={<PublicKudos id={kudosId} />}
      footer={<Footer />}
      header={<Header items={headerButtons} />}
    />
  );
};
